@if (loading) {
  <div class="loading">
    <div class="loading__progression type--flux"></div>
  </div>
}

@if (loading) {
  <span class="sr-only">Loading...</span>
}
